import { useEffect, useState } from "react";
import MarketingHeader from "@/components/MarketingHeader";
import MarketingFooter from "@/components/MarketingFooter";
import { markdownToHtml } from "@/lib/markdown";
import DOMPurify from "dompurify";
import { getCurrentLegalDocumentByType } from "@/integrations/backend/legal";

export default function PrivacyPage() {
  const [content, setContent] = useState<string>("");
  const [title, setTitle] = useState<string>("Privacy Policy");
  const hero =
    "https://xnjrgbjrqhbqsfocowbt.supabase.co/storage/v1/object/public/marketing/alexander-red-d3bYmnZ0ank-unsplash.jpg";

  useEffect(() => {
    const load = async () => {
      const doc = await getCurrentLegalDocumentByType("p" as any);
      if (doc) { setTitle((doc as any).title || "Privacy Policy"); setContent((doc as any).content || ""); }
    };
    load();
  }, []);

  return (
    <>
      <MarketingHeader />
      <main className="min-h-screen gradient-dark pt-24">
        {/* Cinematic hero */}
        <section className="relative min-h-[45vh] flex items-center justify-center overflow-hidden">
          <div className="absolute inset-0">
            <img src={hero} alt="Privacy hero" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-b from-dark-bg/95 via-dark-bg/80 to-dark-bg"></div>
          </div>
          <div className="absolute inset-0 overflow-hidden pointer-events-none">
            <div className="absolute top-0 w-px h-full bg-gradient-to-b from-transparent via-primary/25 to-transparent" style={{ left: 'calc(50% - 220px)' }} />
            <div className="absolute top-0 w-px h-full bg-gradient-to-b from-transparent via-primary/20 to-transparent" style={{ left: 'calc(50% + 220px)' }} />
          </div>
          <div className="container mx-auto px-6 text-center relative z-10">
            <h1 className="text-5xl md:text-6xl font-black text-white leading-tight">{title}</h1>
            <p className="text-gray-light text-xl md:text-2xl mt-3">Your data, your control. This policy explains how we protect it.</p>
          </div>
        </section>

        <section className="py-16">
          <div className="container mx-auto px-6 max-w-4xl">
            <article className="prose prose-invert prose-lg max-w-none prose-headings:font-poppins prose-h1:text-5xl md:prose-h1:text-6xl prose-h2:text-3xl md:prose-h2:text-4xl prose-strong:text-white prose-a:text-primary hover:prose-a:text-lime-hover 
              [&_h1]:text-primary [&_h1]:font-extrabold [&_h2]:text-primary [&_h2]:font-extrabold">
              {content ? (
                <div dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(/^\s*<\w|&lt;/.test(content) ? content : markdownToHtml(content)) }} />
              ) : (
                <p className="text-gray-light">No privacy policy published yet.</p>
              )}
            </article>
          </div>
        </section>
      </main>
      <MarketingFooter />
    </>
  );
}


